import type { CreditScoreRange } from './types/CreditScoreRange';

export const creditScoreRangeArray: CreditScoreRange[] = [
  '800+',
  '740-799',
  '670-739',
  '580-669',
  '579 or lower',
];
